import TextFieldControl, { TextFieldControlProps } from "components/form/TextFieldControl";
import VALIDATION from "helpers/validation";

interface AccordionTextFieldControlProps extends TextFieldControlProps {}

const AccordionTextFieldControl = (props: AccordionTextFieldControlProps) => {
  const { disabled, disabledViewAsText } = props;

  return (
    <TextFieldControl
      rules={{ required: true, ...VALIDATION.competencyMapTitle }}
      stackSx={{
        maxWidth: "100%",
        width: disabled && disabledViewAsText ? "auto" : { xs: "100%", md: 300, lg: 450, xl: 700 },
      }}
      color='secondary'
      onClick={(e) => e.stopPropagation()}
      {...props}
    />
  );
};

export default AccordionTextFieldControl;
